import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);
  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>


      <section className="topbar">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-6 d-none d-lg-block">
              <ul className="topbar_left d-flex flex-wrap">
                <li>
                  <p>Welcome to our <b>SERVIAN</b> Services Company</p>
                </li>
                <li>
                  <a href="callto:+919174282618">
                    <span><img src="assets/images/call_icon_blue.svg" alt="call" className="img-fluid w-100" /></span>
                    +91 9174282618</a>
                </li>
                <li>
                  <a href="mailto:info@sewaxservices.com">
                    <span><img src="assets/images/mail_icon_blue.svg" alt="mail" className="img-fluid w-100" /></span>
                    info@sewaxservices.com</a>
                </li>
              </ul>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="topbar_right d-flex flex-wrap">

                <p style={{ color: "#002257", margin: "10px" }}><b>GST No.</b> 23ABTCS2065C1ZE </p>
                <ul className="icon d-flex flex-wrap">
                  <li><a to="#"><i className="fab fa-facebook-f" aria-hidden="true" /></a></li>
                  <li><a to="#"><i className="fab fa-instagram" aria-hidden="true" /></a></li>
                  <li><a to="#"><i className="fab fa-twitter" aria-hidden="true" /></a></li>
                  <li><a to="#"><i className="fab fa-linkedin-in" aria-hidden="true" /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <nav className="navbar navbar-expand-lg main_menu">
        <div className="container">
          <Link className="navbar-brand" to="/" style={{ width: "55px", height: "55px" }}>
            <img src="./assets/img/ChatGPT.jpg" alt="SERVIAN" className="" style={{ width: "50px", height: "50px", marginTop: "-10px" }} />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i className="far fa-stream menu_icon_bar" aria-hidden="true" />
            <i className="far fa-times close_icon_close" aria-hidden="true" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav m-auto">

              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about-us">About Us</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" to="#">Our Services <i className="fas fa-chevron-down" aria-hidden="true" /></a>
                <ul className="droap_menu">
                  <li><Link to="/property-dealer">Property Dealer Services</Link></li>
                  <li><Link to="/security-services">Security Services</Link></li>
                  <li><Link to="/construction">Construction Services</Link></li>
                  <li><Link to="/financial-advisor">Financial Advisor Services</Link></li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/our-blog">Our Blog</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">Our Career</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact-us">Contact Us</Link>
              </li>

            </ul>
            <ul className="right_menu d-flex flex-wrap">
              <li><Link className="hire_btn common_btn_2" to="https://wa.me/+919174282618">Book Appointment <i className="far fa-long-arrow-right" aria-hidden="true" /></Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>



    </>
  )
}
export default Hadear